import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import AddItem from '@wix/da-ds/pkg/AddItem';
import useTierPopup from '@wix/da-shared-react/pkg/Tier/TierPopup/useTierPopup';
import { BiData, type TierAddNewBiEvent } from '@wix/da-bi/pkg/events';
import { getIsMyTiersPage } from '../../../selectors/studio';

interface Props {
  width: number;
  height: number;

  /**
   * Determines the value of the `is_empty_state_view` biData field for {@link TierAddNewBiEvent}
   */
  hasTiers: boolean;
}

const CreateTierCard: FC<Props> = ({ width, height, hasTiers }) => {
  const { t } = useTranslation();
  const isMyTiersPage = useSelector(getIsMyTiersPage);
  const openCreateTierPopup = useTierPopup(
    undefined,
    Url.studio({
      published: isMyTiersPage ? 'tiers' : 'galleries',
    })
  );

  return (
    <AddItem
      style={{
        width: `${width - 2}px`,
        height: `${height + 54}px`,
      }}
      subtitle={t('studio.published.tierList.create')}
      onClick={openCreateTierPopup}
      biData={BiData<TierAddNewBiEvent>({
        evid: 530,
        is_empty_state_view: hasTiers ? 0 : 1,
      })}
    />
  );
};
CreateTierCard.displayName = 'CreateTierCard';

export default CreateTierCard;
